import cx from 'classnames';
import PropTypes from 'prop-types';
import { Component, createRef } from 'react';

import './SelectBox.scss';

const propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  disableOption: PropTypes.string,
  ellipsis: PropTypes.bool,
  name: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      text: PropTypes.string.isRequired,
    }).isRequired
  ),
  style: PropTypes.object, // eslint-disable-line  react/forbid-prop-types
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
};

const defaultProps = {
  className: '',
  disabled: false,
  disableOption: '',
  ellipsis: false,
  name: '',
  options: [],
  style: {},
  value: '',
  onChange() {},
};

class SelectBox extends Component {
  constructor(props) {
    super(props);
    this.selectBoxRef = createRef();
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const { ellipsis, options, value } = this.props;
    if (this.selectBoxRef.current && ellipsis) {
      const { text } = options.find((option) => option.value === value);
      this.selectBoxRef.current.dataset.content = text;
    }
  }

  componentDidUpdate() {
    const { ellipsis, options, value } = this.props;
    if (this.selectBoxRef.current && ellipsis) {
      const { text } = options.find((option) => option.value === value);
      this.selectBoxRef.current.dataset.content = text;
    }
  }

  handleChange(e) {
    const { ellipsis, onChange } = this.props;
    if (this.selectBoxRef.current && ellipsis) {
      this.selectBoxRef.current.dataset.content = e.target.value;
    }
    onChange(e.target.value);
  }

  render() {
    const { className, disabled, disableOption, ellipsis, name, options, style, value } =
      this.props;

    return (
      <div
        className={cx('SelectBox', className, {
          'SelectBox--ellipsis': !ellipsis,
        })}
        data-content=""
        ref={this.selectBoxRef}
      >
        <select
          className="SelectBox__select"
          data-testid={`${name}SelectBox`}
          disabled={disabled}
          name={name}
          style={style}
          value={value}
          onChange={this.handleChange}
        >
          {options.map((option, key) => (
            <option
              className="SelectBox__option"
              disabled={disableOption === option.value}
              key={key} // eslint-disable-line react/no-array-index-key
              value={option.value}
            >
              {option.text}
            </option>
          ))}
        </select>
      </div>
    );
  }
}

SelectBox.propTypes = propTypes;
SelectBox.defaultProps = defaultProps;

export default SelectBox;
